import { lazyWithRetry } from 'components/lazyUtil.js'

const ConversationsWrapper = lazyWithRetry(() => import('../../conversations'))

// IMPORTANT //
// In Future: whenever new route path is added ensure to update "validPaths" in /server/validRoutes.js
const routes = [
  {
    path: '/conversations',
    component: ConversationsWrapper,
    is_private: true,
  },
  {
    path: '/conversations/:conversationId',
    component: ConversationsWrapper,
    is_private: true,
  },
]

export default routes
